import { make } from 'vuex-pathify'
import repository from '../../apis/repository'

const state = {
	totalItems: 0,
	items: [],
	options: {},
	category: 0,
	search: '',
	item: {},
	categories: [],
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	async datatable({ commit }) {
		const { options, search, category } = state
		const { data } = await repository.feedback.datatable({ ...options, search, category })
		commit('SET_ITEMS', data.data)
		commit('SET_TOTAL_ITEMS', data.total)

		return data.data
	},
	async feedback_category({ commit }) {
		const { data } = await repository.feedback.categories()
		console.log(data)
		commit('SET_CATEGORIES', data.feedback_categories)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
